import React from "react";
import Label from "components/general/Label"
import SportCode from "components/common/SportCode";
import { findArray, arraysEqual } from 'helpers/utils'
import useViewport from "components/general/useViewPort";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const discipline = mirs_discipline;
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    //let hasSecondVault = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? true : false

    //ESL data
    const eslData = row?.extCompetitor

    const dataExtendedResults = ((row?.extendedResults && row.extendedResults.length > 0))
        ? row.extendedResults
        : undefined


    const dataCurrents = row?.extendedResultsCurrent

    //filter by currents
    const dataCurrentsFind =
        Array.isArray(row?.extendedResultsCurrent) &&
        row?.extendedResultsCurrent?.filter(extCurrtentItem =>
            extCurrtentItem.er_code === 'STAGE' &&
            extCurrtentItem.er_type === 'ER' &&
            extCurrtentItem.er_value === "CURRENT"
        )

    //get data from current if exists            
    const data = (dataCurrentsFind)
        ? dataCurrents
        : dataExtendedResults



    const posFirtsColumn = findArray(data, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ["1"] }) ? true : false;
    let hasSecondVault = findArray(data, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ["2"] }) ? true : false;

    const dificulty = findArray(data, { er_type: ['ER'], er_code: ['DIFFICULTY'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
    const execution = findArray(data, { er_type: ['ER'], er_code: ['EXECUTION'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value
    const penalty = findArray(data, { er_type: ['ER'], er_code: ['PENALTY'], ...(posFirtsColumn && { er_pos: ["1"] }) }).er_value
    let score = findArray(data, { er_type: ['ER'], er_code: ['SCORE'], ...(posFirtsColumn && { er_pos: ["1"] }) })?.er_value

    const dificulty2 = findArray(data, { er_type: ['ER'], er_code: ['DIFFICULTY'], er_pos: ['2'] })?.er_value
    const execution2 = findArray(data, { er_type: ['ER'], er_code: ['EXECUTION'], er_pos: ['2'] })?.er_value
    const penalty2 = findArray(data, { er_type: ['ER'], er_code: ['PENALTY'], er_pos: ['2'] })?.er_value
    const score2 = findArray(data, { er_type: ['ER'], er_code: ['SCORE'], er_pos: ['2'] })?.er_value

    const scoreValue = (row.resultType === 'IRM')
        ? row?.resultIrm
        : score

    // let hasSecondVault = findArray(data, { er_type: ['ER'], er_code: ['SCORE'], er_pos: ['2'] }) ? true : false
    //let hasSecondVault = findArray(data, { er_type: ['ER'], er_code: ['SCORE'], er_pos: ["1"] }) ? true : false
    //let hasSecondVault = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? true : false
    score = score ? score : row.resultData;

    return (
        <>



            {eslData && <div className="text-wrap text-start mirs-esl">{eslData}</div>}
            <table className={`table table-detail ${isMobile ? " w-100" : "w-40"}`} >
                <thead className={hasSecondVault ? "" : "d-none"}>
                    <tr>
                        <th className="w-20 text-start"></th>
                        <th className="text-end w-20"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} />:&nbsp;1</th>
                        {hasSecondVault && <th className="text-end w-20"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} />:&nbsp;2</th>}
                    </tr>
                </thead>
                <tbody>
                    <tr><th className="w-20 text-start" > <Label data="HeaderDifficulty" /></th><td className="text-end">{dificulty}</td>{hasSecondVault && <td className="text-end">{dificulty2}</td>}</tr>
                    <tr><th className="text-start"> <Label data="HeaderExecution" /></th><td className="text-end">{execution}</td>{hasSecondVault && <td className="text-end">{execution2}</td>}</tr>
                    <tr><th className="text-start"> <Label data="HeaderPenalty" /></th><td className="text-end">{penalty}</td>{hasSecondVault && <td className="text-end">{penalty2}</td>}</tr>
                    <tr><th className="text-start"> <Label data="HeaderScore" /></th><td className="text-end">{score}</td>{hasSecondVault && <td className="text-end">{score2}</td>}</tr>
                </tbody>
            </table>

        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});



